import React, {useState, useEffect} from 'react';
import dal from '../data/DAL';
import {NavBar, Icon, Toast, ActivityIndicator, WhiteSpace, WingBlank, Flex, Button} from 'antd-mobile';
import Question from '../models/Question';
import FlexItem from 'antd-mobile/lib/flex/FlexItem';
import {Link} from 'react-router-dom';
import moment from 'moment'

const QuestionRecord: React.FC = () => {
    const [questionList, setQuestionList] = useState(new Array<Question>());
    const [animating, setAnimating] = useState(false);

    useEffect(() => {
        setAnimating(true);
        dal.getListTicket().then(() => {
            setAnimating(false);
            setQuestionList(dal.state.questions)
        })
    }, []);


    return (
        <div>
            <NavBar
                mode="light"
                //icon={<Link to={"/charge-plan"}><Icon color={'#666666'} size={'lg'} type="left"/></Link>}
                icon={<Icon color={'#666666'} size={'lg'} type="left"/>}
                onLeftClick={() => {
                    window.history.back()
                }}
                rightContent={[]}>
                提问记录
            </NavBar>
            <WhiteSpace size="lg"/>
            <WingBlank>
                <Flex style={{flexDirection: 'column'}}>
                    {questionList.map(r => {
                        return (
                            <FlexItem key={r.id} className={"renew-log-item"}>
                                <Link to={{pathname: '/question-detail', state: {ticketId: r.id}}}>
                                    <div style={{marginBottom: '1em', color: 'grey'}}>
                                        {r.content}
                                    </div>
                                    <div style={{float: 'left'}}>
                                        {moment(r.createTimeMills).format('YYYY-MM-DD HH:mm:ss')}
                                    </div>
                                </Link>
                            </FlexItem>
                        )
                    })}
                </Flex>
                <p hidden={animating || questionList.length !== 0} style={{textAlign: 'center'}}>暂无提问记录</p>
            </WingBlank>
            <ActivityIndicator toast text="正在加载" animating={animating}/>
            <div className={'white-item'}/>
            <div className={"sticky-footer"}>
                <div className="card-tile">
                    <div style={{flex: 1}}>
                        <Link className={""} to={'/add-question'}>
                            <Button type="ghost">提问</Button>
                        </Link>
                    </div>
                </div>
                {/*<Button type={"ghost"} >添加到主屏幕</Button>*/}
            </div>
        </div>
    );
}
export default QuestionRecord;